import React, { useState } from "react";
import Select from "react-select";
import DataTable from "react-data-table-component";
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export default function Trips() {
    const [selectedParameter, setSelectedParameter] = useState(null);
    const [searchText, setSearchText] = useState("");

    const vehicleOptions = [...Array(10).keys()].map((i) => ({
        value: `KA0${i + 1}AB1234`,
        label: `KA0${i + 1}AB1234`,
    }));

    const data = [
        { id: 1, vehicleNo: "KA01AB1234", startTime: "10:00 AM", endTime: "11:30 AM", duration: "1h 30m", cycles: 1, startSoc: "20%", chrgMode: "Fast", endSoc: "80%", socAccumulation: "60%", location: "Bangalore" },
        { id: 2, vehicleNo: "KA02CD5678", startTime: "09:15 AM", endTime: "10:45 AM", duration: "1h 30m", cycles: 2, startSoc: "15%", chrgMode: "Slow", endSoc: "70%", socAccumulation: "55%", location: "Mysore" },
        { id: 3, vehicleNo: "KA03EF9101", startTime: "02:00 PM", endTime: "04:00 PM", duration: "2h 00m", cycles: 1, startSoc: "10%", chrgMode: "Fast", endSoc: "90%", socAccumulation: "80%", location: "Hubli" },
        { id: 4, vehicleNo: "KA04GH1121", startTime: "08:00 AM", endTime: "09:30 AM", duration: "1h 30m", cycles: 3, startSoc: "25%", chrgMode: "Slow", endSoc: "75%", socAccumulation: "50%", location: "Belgaum" },
        { id: 5, vehicleNo: "KA05IJ3141", startTime: "12:00 PM", endTime: "01:30 PM", duration: "1h 30m", cycles: 1, startSoc: "30%", chrgMode: "Fast", endSoc: "85%", socAccumulation: "55%", location: "Mangalore" },
        { id: 6, vehicleNo: "KA06KL5161", startTime: "03:00 PM", endTime: "05:00 PM", duration: "2h 00m", cycles: 2, startSoc: "20%", chrgMode: "Slow", endSoc: "80%", socAccumulation: "60%", location: "Shimoga" },
        { id: 7, vehicleNo: "KA07MN7181", startTime: "06:00 AM", endTime: "07:30 AM", duration: "1h 30m", cycles: 1, startSoc: "10%", chrgMode: "Fast", endSoc: "90%", socAccumulation: "80%", location: "Gulbarga" },
    ];

    const columns = [
        { name: "S.No", selector: (row) => row.id, sortable: true },
        { name: "Vehicle No", selector: (row) => row.vehicleNo, sortable: true },
        { name: "Start Time", selector: (row) => row.startTime, sortable: true },
        { name: "End Time", selector: (row) => row.endTime, sortable: true },
        { name: "Charge Duration", selector: (row) => row.duration, sortable: true },
        { name: "No. of Charge Cycles", selector: (row) => row.cycles, sortable: true },
        { name: "Start (SoC)", selector: (row) => row.startSoc, sortable: true },
        { name: "ChrgMode", selector: (row) => row.chrgMode, sortable: true },
        { name: "End (SoC)", selector: (row) => row.endSoc, sortable: true },
        { name: "SoC Accumulation", selector: (row) => row.socAccumulation, sortable: true },
        { name: "Location", selector: (row) => row.location, sortable: true },
    ];

     const handleExportPDF = () => {
        const doc = new jsPDF();
        autoTable(doc, {
            head: [columns.map((col) => col.name)],
            body: filteredData.map((row) => columns.map((col) => row[col.selector ? col.selector(row) : row[col.name]])),
        });
        doc.save("trips-data.pdf");
    };
    const customStyles = {
        headCells: {
            style: {
                backgroundColor: "#888888 ",
                color: "#ffffff",
                fontWeight: "bold",
            },
        },
    };
    const filteredData = data.filter((row) =>
        Object.values(row).some((val) =>
            val.toString().toLowerCase().includes(searchText.toLowerCase())
        )
    );

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 className="mb-sm-0 font-size-18">Charging  </h4>
                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item"><a href="#/">Dashboard</a></li>
                                <li className="breadcrumb-item active">Charging </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header p-1 pt-2">
                            <div className="row mb-3 d-flex justify-content-center">
                                <div className="col-sm-12 col-md-12 col-lg-3 mb-1">
                                    <label>Select Vehicle</label>
                                    <Select
                                        options={vehicleOptions}
                                        value={selectedParameter}
                                        onChange={setSelectedParameter}
                                        isSearchable={true} // Enables search
                                        placeholder="Select Vehicle"
                                        className="basic-single"
                                        classNamePrefix="select"
                                    />
                                </div>

                                <div className="col-sm-12 col-md-12 col-lg-2 mb-1">
                                    <label>From</label>
                                    <input type="date" className="form-control" />
                                </div>
                                <div className="col-sm-12 col-md-12 col-lg-2 mb-1">
                                    <label>To</label>
                                    <input type="date" className="form-control" />
                                </div>
                                <div className="col-md-1 mt-4">
                                    <input type="submit" value="Search" className="mt-1 btn btn-primary waves-effect waves-light" />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="d-flex justify-content-between mb-3">
                                <div>
                                    <CSVLink data={filteredData} filename="trips-data.csv" className="btn btn-primary btn-sm me-2">
                                        Export to CSV
                                    </CSVLink>
                                    <button onClick={handleExportPDF} className="btn btn-danger btn-sm">
                                        Export to PDF
                                    </button>
                                </div>
                                <div className="col-lg-2">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search..."
                                        value={searchText}
                                        onChange={(e) => setSearchText(e.target.value)}
                                    />
                                </div>
                            </div>
                            <DataTable
                                columns={columns}
                                data={filteredData}
                                pagination
                                highlightOnHover
                                responsive
                                customStyles={customStyles}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
